import { Button } from "@mui/material";
import { useFormikContext } from "formik";
import { memo, useRef } from "react";
import { StyledGoogleMaps } from "../../../styled/googleMaps";
import { applyDefaultsFieldToPuntos } from "./fptTrasladosUtils";
import TramoGestionFields from "./tramoGestionFields";

const TramoGestionDefaults = memo(({
  disabled,
  tiposTransporte,
  motivosTraslado,
  agencias,
  prestadoresTraslado,
  showAgencia,
  idEstadoInicial,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const valuesRef = useRef(values);
  valuesRef.current = values;

  const handleApplyField = (fieldKey) => {
    const currentValues = valuesRef.current || {};
    const currentDefaults = { ...(currentValues.tramosDefaults || {}) };

    const nextPuntos = applyDefaultsFieldToPuntos(
      currentValues.puntos,
      currentDefaults,
      fieldKey,
      idEstadoInicial,
    );
    if (nextPuntos !== currentValues.puntos) {
      setFieldValue("puntos", nextPuntos, false);
    }
    if (fieldKey === "idTipoTransporte") {
      setFieldValue(
        "tipoTransporteNombre",
        currentDefaults?.idTipoTransporte,
        false,
      );
    }
  };

  return (
    <StyledGoogleMaps.DefaultsPanel>
      <StyledGoogleMaps.GestionPanelTitle variant="subtitle1">
        Valores por defecto para todos los tramos
      </StyledGoogleMaps.GestionPanelTitle>
      <TramoGestionFields
        afterField={(fieldKey) => (
          <Button
            disabled={disabled}
            type="button"
            onClick={() => handleApplyField(fieldKey)}
            variant="outlined">
            Aplicar a todos los tramos
          </Button>
        )}
        agencias={agencias}
        prestadoresTraslado={prestadoresTraslado}
        disabled={disabled}
        motivosTraslado={motivosTraslado}
        namePrefix="tramosDefaults"
        showAgencia={showAgencia}
        tiposTransporte={tiposTransporte}
      />
    </StyledGoogleMaps.DefaultsPanel>
  );
});

TramoGestionDefaults.displayName = "TramoGestionDefaults";

export default TramoGestionDefaults;
